{
    "joz9e": {
        "position": {
            "x": 3,
            "y": 30,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "joz9e"
    },
    "wddD3": {
        "position": {
            "x": 3,
            "y": 33,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "wddD3"
    },
    "HxvaC": {
        "position": {
            "x": 2,
            "y": 31,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "HxvaC"
    },
    "P02cN": {
        "position": {
            "x": 1,
            "y": 38,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "P02cN"
    },
    "KK5uR": {
        "position": {
            "x": 2,
            "y": 35,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "KK5uR"
    },
    "Nuflx": {
        "position": {
            "x": 4,
            "y": 37,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "Nuflx"
    },
    "BBlBj": {
        "position": {
            "x": 5,
            "y": 36,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "BBlBj"
    },
    "fQ5sP": {
        "position": {
            "x": 3,
            "y": 42,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "fQ5sP"
    },
    "XOuZn": {
        "position": {
            "x": 5,
            "y": 43,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "XOuZn"
    },
    "wzlLT": {
        "position": {
            "x": 3,
            "y": 41,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "wzlLT"
    },
    "d-6-w": {
        "position": {
            "x": 12,
            "y": 30,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "d-6-w"
    },
    "-64oa": {
        "position": {
            "x": 13,
            "y": 33,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "-64oa"
    },
    "z8B8A": {
        "position": {
            "x": 16,
            "y": 31,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "z8B8A"
    },
    "eC63M": {
        "position": {
            "x": 13,
            "y": 30,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "eC63M"
    },
    "Fh_YU": {
        "position": {
            "x": 15,
            "y": 33,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "Fh_YU"
    },
    "OXTO5": {
        "position": {
            "x": 14,
            "y": 35,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "OXTO5"
    },
    "Wa-2O": {
        "position": {
            "x": 13,
            "y": 36,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "Wa-2O"
    },
    "OcX-k": {
        "position": {
            "x": 14,
            "y": 38,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "OcX-k"
    },
    "9K392": {
        "position": {
            "x": 16,
            "y": 37,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "9K392"
    },
    "5bKuR": {
        "position": {
            "x": 16,
            "y": 38,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "5bKuR"
    },
    "VF7i8": {
        "position": {
            "x": 15,
            "y": 43,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "VF7i8"
    },
    "9N-a0": {
        "position": {
            "x": 15,
            "y": 42,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "9N-a0"
    },
    "5Ziqz": {
        "position": {
            "x": 14,
            "y": 43,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "5Ziqz"
    },
    "CBwzM": {
        "position": {
            "x": 15,
            "y": 41,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "CBwzM"
    },
    "ZrUN8": {
        "position": {
            "x": 16,
            "y": 43,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "ZrUN8"
    },
    "c05qy": {
        "position": {
            "x": 15,
            "y": 44,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "c05qy"
    },
    "9F3md": {
        "position": {
            "x": 29,
            "y": 38,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "9F3md"
    },
    "BQ4gb": {
        "position": {
            "x": 28,
            "y": 39,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "BQ4gb"
    },
    "RzT3c": {
        "position": {
            "x": 29,
            "y": 39,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "RzT3c"
    },
    "-VmQH": {
        "position": {
            "x": 28,
            "y": 38,
            "z": 1
        },
        "jobKey": "ember/plant/blackberry",
        "key": "-VmQH"
    },
    "Sr1i_": {
        "position": {
            "x": 29,
            "y": 36,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "Sr1i_"
    },
    "Isfuy": {
        "position": {
            "x": 28,
            "y": 30,
            "z": 1
        },
        "jobKey": "ember/plant/kingbolete",
        "key": "Isfuy"
    },
    "ryQWf": {
        "position": {
            "x": 28,
            "y": 31,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "ryQWf"
    },
    "CJSL9": {
        "position": {
            "x": 30,
            "y": 34,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "CJSL9"
    },
    "T1j8r": {
        "position": {
            "x": 31,
            "y": 33,
            "z": 1
        },
        "jobKey": "ember/plant/ghostturnip",
        "key": "T1j8r"
    },
    "rwUXB": {
        "position": {
            "x": 32,
            "y": 33,
            "z": 1
        },
        "jobKey": "ember/plant/kingbolete",
        "key": "rwUXB"
    },
    "6zBaK": {
        "position": {
            "x": 29,
            "y": 33,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "6zBaK"
    },
    "LHo3a": {
        "position": {
            "x": 27,
            "y": 46,
            "z": 1
        },
        "jobKey": "ember/plant/kingbolete",
        "key": "LHo3a"
    },
    "yMtuy": {
        "position": {
            "x": 29,
            "y": 45,
            "z": 1
        },
        "jobKey": "ember/torch/3",
        "key": "yMtuy"
    },
    "nqctY": {
        "position": {
            "x": 31,
            "y": 44,
            "z": 1
        },
        "jobKey": "ember/plant/kingbolete",
        "key": "nqctY"
    },
    "--nKy": {
        "position": {
            "x": 28,
            "y": 45,
            "z": 1
        },
        "jobKey": "ember/plant/kingbolete",
        "key": "--nKy"
    },
    "blTec": {
        "position": {
            "x": 44,
            "y": 30,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "blTec"
    },
    "fqWU6": {
        "position": {
            "x": 45,
            "y": 34,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "fqWU6"
    },
    "1Hvja": {
        "position": {
            "x": 43,
            "y": 33,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "1Hvja"
    },
    "s5hpg": {
        "position": {
            "x": 44,
            "y": 32,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "s5hpg"
    },
    "2vIaX": {
        "position": {
            "x": 43,
            "y": 37,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "2vIaX"
    },
    "3lfbK": {
        "position": {
            "x": 44,
            "y": 39,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "3lfbK"
    },
    "QbMN-": {
        "position": {
            "x": 45,
            "y": 38,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "QbMN-"
    },
    "FqfYE": {
        "position": {
            "x": 47,
            "y": 38,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "FqfYE"
    },
    "kr9jB": {
        "position": {
            "x": 43,
            "y": 43,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "kr9jB"
    },
    "KX_A2": {
        "position": {
            "x": 44,
            "y": 45,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "KX_A2"
    },
    "MBVMT": {
        "position": {
            "x": 46,
            "y": 47,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "MBVMT"
    },
    "XLuB1": {
        "position": {
            "x": 45,
            "y": 46,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "XLuB1"
    },
    "Mn8pW": {
        "position": {
            "x": 57,
            "y": 32,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "Mn8pW"
    },
    "saVu0": {
        "position": {
            "x": 58,
            "y": 32,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "saVu0"
    },
    "PUXmc": {
        "position": {
            "x": 56,
            "y": 34,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "PUXmc"
    },
    "aSLXW": {
        "position": {
            "x": 55,
            "y": 39,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "aSLXW"
    },
    "dtGVw": {
        "position": {
            "x": 55,
            "y": 36,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "dtGVw"
    },
    "0mdEI": {
        "position": {
            "x": 58,
            "y": 36,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "0mdEI"
    },
    "aRpzQ": {
        "position": {
            "x": 58,
            "y": 39,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "aRpzQ"
    },
    "y2zlz": {
        "position": {
            "x": 57,
            "y": 44,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "y2zlz"
    },
    "43ISD": {
        "position": {
            "x": 57,
            "y": 42,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "43ISD"
    },
    "_yOXR": {
        "position": {
            "x": 58,
            "y": 45,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "_yOXR"
    },
    "Qjzob": {
        "position": {
            "x": 57,
            "y": 43,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "Qjzob"
    },
    "mGVfV": {
        "position": {
            "x": 73,
            "y": 46,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "mGVfV"
    },
    "PZjKp": {
        "position": {
            "x": 73,
            "y": 42,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "PZjKp"
    },
    "jelNY": {
        "position": {
            "x": 76,
            "y": 44,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "jelNY"
    },
    "deU9D": {
        "position": {
            "x": 74,
            "y": 44,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "deU9D"
    },
    "CAksl": {
        "position": {
            "x": 73,
            "y": 36,
            "z": 1
        },
        "jobKey": "ember/plant/lanternonion",
        "key": "CAksl"
    },
    "HDvAk": {
        "position": {
            "x": 72,
            "y": 40,
            "z": 1
        },
        "jobKey": "ember/plant/lanternonion",
        "key": "HDvAk"
    },
    "KMnnK": {
        "position": {
            "x": 76,
            "y": 38,
            "z": 1
        },
        "jobKey": "ember/plant/lanternonion",
        "key": "KMnnK"
    },
    "irSVU": {
        "position": {
            "x": 72,
            "y": 37,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "irSVU"
    },
    "KEVCu": {
        "position": {
            "x": 72,
            "y": 34,
            "z": 1
        },
        "jobKey": "ember/plant/lanternonion",
        "key": "KEVCu"
    },
    "MJBaN": {
        "position": {
            "x": 73,
            "y": 31,
            "z": 1
        },
        "jobKey": "ember/plant/lanternonion",
        "key": "MJBaN"
    },
    "m-i2N": {
        "position": {
            "x": 76,
            "y": 33,
            "z": 1
        },
        "jobKey": "ember/plant/lanternonion",
        "key": "m-i2N"
    },
    "l9c79": {
        "position": {
            "x": 72,
            "y": 30,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "l9c79"
    },
    "bcHa7": {
        "position": {
            "x": 89,
            "y": 42,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "bcHa7"
    },
    "5rptF": {
        "position": {
            "x": 90,
            "y": 38,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "5rptF"
    },
    "EPoSe": {
        "position": {
            "x": 89,
            "y": 38,
            "z": 1
        },
        "jobKey": "ember/plant/foxshroom",
        "key": "EPoSe"
    },
    "6dnr9": {
        "position": {
            "x": 87,
            "y": 36,
            "z": 1
        },
        "jobKey": "ember/plant/foxshroom",
        "key": "6dnr9"
    },
    "wvRhD": {
        "position": {
            "x": 88,
            "y": 33,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "wvRhD"
    },
    "2isvr": {
        "position": {
            "x": 89,
            "y": 31,
            "z": 1
        },
        "jobKey": "ember/plant/foxshroom",
        "key": "2isvr"
    },
    "d-Rh0": {
        "position": {
            "x": 87,
            "y": 30,
            "z": 1
        },
        "jobKey": "ember/plant/foxshroom",
        "key": "d-Rh0"
    },
    "NLj78": {
        "position": {
            "x": 100,
            "y": 31,
            "z": 1
        },
        "jobKey": "ember/plant/phantomring",
        "key": "NLj78"
    },
    "prBE3": {
        "position": {
            "x": 102,
            "y": 30,
            "z": 1
        },
        "jobKey": "ember/torch/1",
        "key": "prBE3"
    },
    "f7QOn": {
        "position": {
            "x": 102,
            "y": 32,
            "z": 1
        },
        "jobKey": "ember/plant/phantomring",
        "key": "f7QOn"
    },
    "J3hwe": {
        "position": {
            "x": 99,
            "y": 35,
            "z": 1
        },
        "jobKey": "ember/plant/cravenberry",
        "key": "J3hwe"
    },
    "v1P4d": {
        "position": {
            "x": 101,
            "y": 37,
            "z": 1
        },
        "jobKey": "ember/plant/cravenberry",
        "key": "v1P4d"
    },
    "8Xrwy": {
        "position": {
            "x": 101,
            "y": 34,
            "z": 1
        },
        "jobKey": "ember/torch/1",
        "key": "8Xrwy"
    },
    "yv9MK": {
        "position": {
            "x": 102,
            "y": 45,
            "z": 1
        },
        "jobKey": "ember/plant/phantomring",
        "key": "yv9MK"
    },
    "QX9N7": {
        "position": {
            "x": 99,
            "y": 40,
            "z": 1
        },
        "jobKey": "ember/plant/phantomring",
        "key": "QX9N7"
    },
    "WmwW5": {
        "position": {
            "x": 101,
            "y": 41,
            "z": 1
        },
        "jobKey": "ember/plant/phantomring",
        "key": "WmwW5"
    },
    "Np-kX": {
        "position": {
            "x": 101,
            "y": 44,
            "z": 1
        },
        "jobKey": "ember/plant/phantomring",
        "key": "Np-kX"
    },
    "HXAc5": {
        "position": {
            "x": 102,
            "y": 42,
            "z": 1
        },
        "jobKey": "ember/torch/1",
        "key": "HXAc5"
    },
    "0gAQ1": {
        "position": {
            "x": 113,
            "y": 30,
            "z": 1
        },
        "jobKey": "ember/plant/cravenberry",
        "key": "0gAQ1"
    },
    "WstjF": {
        "position": {
            "x": 115,
            "y": 33,
            "z": 1
        },
        "jobKey": "ember/plant/cravenberry",
        "key": "WstjF"
    },
    "7ulZv": {
        "position": {
            "x": 116,
            "y": 29,
            "z": 1
        },
        "jobKey": "ember/plant/cravenberry",
        "key": "7ulZv"
    },
    "BHCp9": {
        "position": {
            "x": 113,
            "y": 33,
            "z": 1
        },
        "jobKey": "ember/torch/1",
        "key": "BHCp9"
    },
    "SX2Au": {
        "position": {
            "x": 114,
            "y": 29,
            "z": 1
        },
        "jobKey": "ember/torch/1",
        "key": "SX2Au"
    },
    "oz6Y0": {
        "position": {
            "x": 113,
            "y": 37,
            "z": 1
        },
        "jobKey": "ember/torch/1",
        "key": "oz6Y0"
    },
    "zAN1c": {
        "position": {
            "x": 113,
            "y": 38,
            "z": 1
        },
        "jobKey": "ember/torch/1",
        "key": "zAN1c"
    },
    "Uy4uE": {
        "position": {
            "x": 113,
            "y": 43,
            "z": 1
        },
        "jobKey": "ember/plant/cravenberry",
        "key": "Uy4uE"
    },
    "5ZDR4": {
        "position": {
            "x": 116,
            "y": 45,
            "z": 1
        },
        "jobKey": "ember/plant/cravenberry",
        "key": "5ZDR4"
    },
    "cQQLu": {
        "position": {
            "x": 116,
            "y": 43,
            "z": 1
        },
        "jobKey": "ember/torch/1",
        "key": "cQQLu"
    },
    "3cBGj": {
        "position": {
            "x": 114,
            "y": 42,
            "z": 1
        },
        "jobKey": "ember/torch/1",
        "key": "3cBGj"
    },
    "KWQuN": {
        "position": {
            "x": 117,
            "y": 43,
            "z": 1
        },
        "jobKey": "ember/plant/cravenberry",
        "key": "KWQuN"
    },
    "68qa4": {
        "position": {
            "x": 114,
            "y": 46,
            "z": 1
        },
        "jobKey": "ember/torch/1",
        "key": "68qa4"
    },
    "NyfFR": {
        "position": {
            "x": 115,
            "y": 37,
            "z": 1
        },
        "jobKey": "ember/plant/phantomring",
        "key": "NyfFR"
    },
    "ROMe-": {
        "stack": 10,
        "position": {
            "x": 131,
            "y": 43,
            "z": 1
        },
        "jobKey": "ember/torch/fancy",
        "key": "ROMe-"
    },
    "DX8I0": {
        "position": {
            "x": 132,
            "y": 37,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "DX8I0"
    },
    "J-Bco": {
        "position": {
            "x": 131,
            "y": 32,
            "z": 1
        },
        "jobKey": "ember/torch/2",
        "key": "J-Bco"
    },
    "G8XWQ": {
        "position": {
            "x": 58,
            "y": 30,
            "z": 1
        },
        "jobKey": "ember/plant/crookedroot",
        "key": "G8XWQ"
    },
    "STKC7": {
        "position": {
            "x": 87,
            "y": 45,
            "z": 1
        },
        "jobKey": "ember/plant/foxshroom",
        "key": "STKC7"
    },
    "XTjHg": {
        "position": {
            "x": 89,
            "y": 43,
            "z": 1
        },
        "jobKey": "ember/plant/foxshroom",
        "key": "XTjHg"
    },
    "qEPpW": {
        "position": {
            "x": 88,
            "y": 40,
            "z": 1
        },
        "jobKey": "ember/plant/foxshroom",
        "key": "qEPpW"
    }
}